import React from 'react'

const CleanLargeLogoIcon = (
  <>
    <svg
      aria-hidden="true"
      width="585"
      height="837"
      viewBox="0 0 585 837"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4064_2988)">
        <path
          d="M474.377 487.355C474.527 499.761 472.124 512.066 467.316 523.504C464.171 530.985 460.041 537.991 455.05 544.342C450.582 550.028 442.182 550.133 437.574 544.559C432.418 538.322 428.111 531.405 424.782 523.987C419.697 512.652 417.005 500.391 416.874 487.968C416.743 475.546 419.176 463.23 424.022 451.792C427.192 444.307 431.351 437.304 436.372 430.961C440.863 425.288 449.269 425.219 453.855 430.816C458.97 437.058 463.241 443.97 466.541 451.377C471.588 462.707 474.255 474.952 474.377 487.355Z"
          fill="#FFA300"
        />
        <path
          d="M607.519 712.401C601.117 721.707 592.87 729.597 583.289 735.579C576.965 739.528 570.15 742.59 563.035 744.695C556.83 746.531 550.639 742.276 550.131 735.825C549.547 728.414 549.97 720.94 551.402 713.609C553.57 702.51 558.005 691.977 564.429 682.669C570.853 673.362 579.129 665.48 588.738 659.516C595.082 655.578 601.917 652.533 609.051 650.45C615.265 648.636 621.442 652.921 621.923 659.377C622.473 666.77 622.026 674.222 620.578 681.529C618.384 692.605 613.939 703.113 607.519 712.401Z"
          fill="#FFA300"
        />
        <path
          d="M630.123 535.354C635.915 544.325 639.8 554.391 641.535 564.927C642.647 571.674 642.862 578.522 642.188 585.293C641.547 591.732 635.226 595.816 629.093 593.754C622.631 591.58 616.467 588.561 610.765 584.761C601.868 578.832 594.29 571.131 588.505 562.139C582.72 553.148 578.852 543.06 577.143 532.506C576.049 525.745 575.855 518.886 576.554 512.107C577.219 505.667 583.56 501.608 589.688 503.698C596.123 505.892 602.259 508.925 607.934 512.728C616.801 518.672 624.353 526.373 630.123 535.354Z"
          fill="#CCCCFF"
        />
        <path
          d="M314.707 371.023C327.479 372.806 338.971 376.915 348.468 383.095C354.087 386.75 358.936 391.085 362.923 395.993C367.529 401.665 364.947 409.796 358.276 412.777C348.917 416.959 339.185 420.128 329.38 422.173C315.434 425.082 301.639 425.653 288.86 423.85C276.081 422.046 264.591 417.908 255.11 411.694C249.489 408.01 244.646 403.643 240.674 398.7C236.105 393.012 238.719 384.906 245.389 381.949C254.746 377.8 264.469 374.66 274.261 372.639C288.185 369.765 301.951 369.214 314.707 371.023Z"
          fill="#CCCCFF"
        />
        <path
          d="M274.789 607.548C278.165 594.83 284.12 582.941 292.286 572.623C298.069 565.314 304.874 558.903 312.474 553.579C317.774 549.867 325.009 551.783 327.774 557.633C331.746 566.038 334.483 574.995 335.881 584.226C337.853 597.253 337.116 610.547 333.717 623.277C330.317 636.006 324.328 647.897 316.124 658.207C310.312 665.51 303.477 671.909 295.846 677.213C290.53 680.908 283.299 678.959 280.558 673.094C276.631 664.693 273.933 655.749 272.564 646.537C270.629 633.526 271.387 620.255 274.789 607.548Z"
          fill="#FF0099"
        />
        <circle
          cx="594.53"
          cy="447.802"
          r="34.7608"
          transform="rotate(-136.146 594.53 447.802)"
          fill="#330066"
        />
        <circle
          cx="438.44"
          cy="374.208"
          r="18.218"
          transform="rotate(-136.146 438.44 374.208)"
          fill="#FFD9F0"
        />
        <circle
          cx="425.377"
          cy="594.846"
          r="20.1027"
          transform="rotate(-136.146 425.377 594.846)"
          fill="#CCCCFF"
        />
        <circle
          cx="383.588"
          cy="638.036"
          r="24.5001"
          transform="rotate(-136.146 383.588 638.036)"
          fill="#330066"
        />
        <circle
          cx="407.894"
          cy="549.875"
          r="14.8676"
          transform="rotate(-136.146 407.894 549.875)"
          fill="#FFD9F0"
        />
        <circle
          cx="396.194"
          cy="512.789"
          r="10.8889"
          transform="rotate(-136.146 396.194 512.789)"
          fill="#FF0099"
        />
        <path
          d="M557.793 521.536C556.102 506.684 550.87 491.039 545.885 479.079C542.404 470.725 531.903 469.124 525.849 475.851C515.508 487.341 501.734 504.052 489.331 522.888C466.046 558.252 455.113 588.341 469.884 615.069C484.656 641.798 522.869 642.584 540.925 617.653C558.981 592.723 561.13 550.843 557.793 521.536Z"
          fill="#FF0099"
        />
        <path
          d="M242.802 488.608C254.623 479.46 265.286 466.872 272.928 456.408C278.264 449.099 274.187 439.29 265.296 437.603C250.109 434.72 228.677 431.61 206.14 430.774C163.828 429.206 132.431 435.463 117.239 461.955C102.047 488.446 121.193 521.526 151.873 524.035C182.553 526.543 219.475 506.661 242.802 488.608Z"
          fill="#FFCC00"
        />
        <path
          d="M311.001 352.699C325.862 354.303 342.274 352.627 355.036 350.384C363.949 348.818 367.812 338.923 362.575 331.542C353.631 318.935 340.344 301.833 324.684 285.605C295.282 255.136 268.32 237.876 239.004 246.431C209.689 254.986 200.548 292.099 220.916 315.179C241.284 338.259 281.675 349.533 311.001 352.699Z"
          fill="#FFA300"
        />
        <path
          d="M327.138 442.62C321.364 444.515 315.571 447.493 310.553 450.543C303.633 454.748 304.131 464.202 311.23 468.097C318.025 471.826 326.486 476.032 335.556 479.638C357.369 488.311 374.932 490.87 387.786 479.85C400.64 468.831 396.778 447.995 381.216 440.99C365.654 433.985 342.675 437.519 327.138 442.62Z"
          fill="#FFD9F0"
        />
        <path
          d="M583.602 632.964C578.214 634.524 572.942 630.181 573.443 624.594L575.519 601.423C576.116 594.759 584.161 591.75 588.985 596.385L607.037 613.728C611.463 617.981 609.626 625.43 603.73 627.137L583.602 632.964Z"
          fill="#FFD9F0"
        />
        <path
          d="M376.32 375.625C370.303 374.412 367.856 367.14 371.915 362.536L384.351 348.431C388.411 343.827 395.932 345.344 397.889 351.162L403.886 368.984C405.844 374.801 400.77 380.556 394.753 379.343L376.32 375.625Z"
          fill="#FF0099"
        />
        <path
          d="M381.045 570.605C386.737 572.902 387.807 580.5 382.972 584.28L368.159 595.863C363.323 599.644 356.208 596.772 355.352 590.694L352.728 572.074C351.871 565.996 357.916 561.27 363.607 563.568L381.045 570.605Z"
          fill="#FFCC00"
        />
        <path
          d="M164.578 335.735C165.417 331.737 169.607 329.413 173.443 330.82L232.049 352.312C237.915 354.463 237.905 362.763 232.033 364.9L163.702 389.767C158.764 391.564 153.773 387.237 154.852 382.094L164.578 335.735Z"
          fill="#FF0099"
        />
        <rect
          x="409.879"
          y="430.232"
          width="25.5471"
          height="25.5471"
          rx="6.70089"
          transform="rotate(-151.146 409.879 430.232)"
          fill="#330066"
        />
        <rect
          x="265.238"
          y="567.594"
          width="52.7401"
          height="40.9336"
          rx="9.42331"
          transform="rotate(-126.836 265.238 567.594)"
          fill="#CCCCFF"
        />
        <rect
          x="545.74"
          y="626.139"
          width="31.6708"
          height="51.63"
          rx="10.1482"
          transform="rotate(44.6697 545.74 626.139)"
          fill="#CCCCFF"
        />
        <rect
          x="520.178"
          y="699.283"
          width="95.0688"
          height="96.3252"
          rx="16.672"
          transform="rotate(133.854 520.178 699.283)"
          fill="#FFCC00"
        />
        <path
          d="M369.578 536.062C371.76 541.955 365.922 547.644 360.088 545.31L310.157 525.334C308.951 524.852 307.897 524.054 307.105 523.024L282.94 491.616C278.136 485.372 285.404 476.905 292.333 480.654C301.863 485.811 311.911 491.16 319.779 495.141C334.458 502.567 347.508 505.409 354.162 506.455C356.989 506.9 359.467 508.761 360.461 511.445L369.578 536.062Z"
          fill="#330066"
        />
      </g>
      <defs>
        <clipPath id="clip0_4064_2988">
          <rect
            width="624.838"
            height="821.277"
            fill="white"
            transform="translate(0 468.082) rotate(-48.5146)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
)

export default CleanLargeLogoIcon
